import { Avatar } from '@mui/material'
import AvatarGroup from '@mui/material/AvatarGroup'
import { memo } from 'react'
import { makeStyles } from 'tss-react/mui'

import LegacySvg from '../shared/LegacySvg'

const useStyles = makeStyles()((theme) => ({
  platformAvatar: {
    borderColor: theme.palette.background.paper,
    borderRadius: '50%',
    width: 24,
    height: 24,
  },
}))

const PlatformAvatarGroup = (props) => {
  // Allows users of the component to override classes.
  const { classes } = useStyles()

  return (
    <AvatarGroup max={100}>
      {props.platforms.map((p) => {
        const svgSymbol = platformData[p]

        if (!svgSymbol) {
          console.error(`No svg for platform: ${p}`)
          return null
        }

        return (
          <Avatar
            className={classes.platformAvatar}
            key={p}
            style={props.borderColor ? { borderColor: props.borderColor } : {}}
          >
            <LegacySvg height="24px" symbol={svgSymbol} width="24px" />
          </Avatar>
        )
      })}
    </AvatarGroup>
  )
}

const platformData = {
  'facebook': 'facebook',
  'instagram': 'instagram',
  'messenger': 'fb-messenger',
  'email': 'email',
  'twitter': 'twitter',
  'asset': 'downloadables',
  'assets': 'downloadables',
  'embed': 'banner',
  'audience network': 'fb-audience',
}

export default memo(PlatformAvatarGroup)
